import { BaseService } from "./../base";
export class ProvinceService extends BaseService {
  static get entity() {
    return "province";
  }
  static get name() {
    return "province";
  }

  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }

  static async getByRegionId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find/${id}`, this.name);
  }
}
